import { createSlice } from "@reduxjs/toolkit";

const pagodecomisionespdfState = {
  pagodecomisionespdfdata: [],
};

const pagodecomisionespdfSlice = createSlice({
  name: "pagodecomisionespdf",
  initialState: pagodecomisionespdfState,
  reducers: {
    PagoDeComisionesPDFData: (state, actions) => actions.payload,
    CleanPagoDeComisionesPDFData: () => pagodecomisionespdfState,
  },
});

export const { PagoDeComisionesPDFData, CleanPagoDeComisionesPDFData } = pagodecomisionespdfSlice.actions;

export default pagodecomisionespdfSlice.reducer;